/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type ProductQueries, ProductQueriesSchema } from './product-query'

/* TypeScript */
export type ProductsBlockApiProps = {
  technicalName?: Maybe<string>
  productQueries: ProductQueries
  title: string
  subtitle: string
  ctaLink?: Maybe<CTALink>
}

/* Schemas */
export const ProductsBlockApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  productQueries: ProductQueriesSchema,
  title: z.string(),
  subtitle: z.string(),
  ctaLink: z.nullish(CTALinkSchema),
})

/* Schemas validation */
type TestProductsBlockApiProps = ExpectTrue<
  Equal<ProductsBlockApiProps, z.infer<typeof ProductsBlockApiPropsSchema>>
>
